/* eslint-disable @typescript-eslint/no-explicit-any */
import { Field, useField } from "formik";
import React, { useEffect } from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { DropdownOption } from "../../helpers/optionSets";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { useSetFieldTouched } from "../useSetFieldTouched";
import * as styles from "./DropdownField.module.css";

export type DropdownFieldProps = Readonly<{
  values: Array<DropdownOption>;
  name: string;
  type?: "string" | "number";
  onSelectedCountryOrRegion?: (vale: string) => void;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const DropdownField = (props: DropdownFieldProps) => {
  const { values, name, type, disabled, onSelectedCountryOrRegion } = props;
  const [field, _meta, helpers] = useField(props);
  useSetFieldTouched(field.name);

  const onChange =
    type === "number"
      ? (event: any) => helpers.setValue(parseInt(event.target.value, 10))
      : (event: any) => helpers.setValue(event.target.value);

  useEffect(() => {
    if (field.value && onSelectedCountryOrRegion) {
      onSelectedCountryOrRegion(field.value);
    }
  }, [field.value, name, onSelectedCountryOrRegion]);

  const getCurrentLabel = () => {
    const selectedOption = values.find(option => option.value === field.value);
    return selectedOption?.label ?? "";
  };

  return (
    <Row className={commonStyles.container}>
      <Column>
        <FieldHeader {...props} />
        {disabled && <span>{getCurrentLabel()}</span>}
        {!disabled && (
          <Field
            as="select"
            name={name}
            className={styles.dropdown}
            data-testid={name}
            onChange={onChange}
            aria-label={name}
            disabled={props.isSaving}
          >
            {values.map(valueGroup => (
              <option
                key={`dropdown-${name}-${valueGroup.value}`}
                value={valueGroup.value}
                className={commonStyles.textFieldText}
              >
                {valueGroup.label}
              </option>
            ))}
          </Field>
        )}
        <FieldErrorMessage fieldName={field.name} />
      </Column>
    </Row>
  );
};
